import { create } from 'zustand';

import { HoleInOneClaimDetails } from '@/api/holeInOneClaim/holeInOneClaim.types.ts';

interface HoleInOneClaimDetailsState {
  holeInOneClaimDetails: HoleInOneClaimDetails | null;
  setHoleInOneClaimDetails: (
    holeInOneClaimDetails: HoleInOneClaimDetails
  ) => void;
  reset: () => void;
}

export const useHoleInOneClaimDetailsStore = create<HoleInOneClaimDetailsState>(
  (set) => ({
    holeInOneClaimDetails: null,
    setHoleInOneClaimDetails: (
      holeInOneClaimDetails: HoleInOneClaimDetails
    ): void => set({ holeInOneClaimDetails }),
    reset: (): void => set({ holeInOneClaimDetails: null }),
  })
);
